import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import PartnersPage from '../pages/partners/page';
import GalleryPage from '../pages/gallery/page';
import AdminPage from '../pages/admin/page';
import UserDashboard from '../components/user/UserDashboard';
import InquiryPage from '../pages/inquiry/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/inquiry',
    element: <InquiryPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/dashboard',
    element: <UserDashboard />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
